import { z } from "zod";

import { responseErrorSchema } from "../Cases/types";

// to avoid "typecheck" errors in V2 when importing from V1
export interface DeprecatedReduxState {
  session: {
    profile: {
      userId: string;
      type: string;
      pricingMsa: string;
      status?: string;
    } | null;
    admin: boolean;
  };
}

export const userSchema = z.object({
  email: z.string(),
  _id: z.string(),
  type: z.string(),
  employee: z
    .object({
      name: z.string(),
    })
    .optional(),
});
export type User = z.infer<typeof userSchema>;

export const userListSchema = z.object({
  users: z.array(
    z.object({
      email: z.string(),
      _id: z.string(),
    })
  ),
});

export const facilityUserSchema = z.object({
  archived: z.boolean().optional(),
  roles: z.array(z.string()),
  name: z.string(),
  email: z.string(),
  _id: z.string(),
});
export type FacilityUser = z.infer<typeof facilityUserSchema>;

export const facilityUsersResponseSchema = z.array(facilityUserSchema);
export type FacilityUsersResponse = z.infer<typeof facilityUsersResponseSchema>;

export const activeUsersResponseSchema = z.object({
  users: z.array(
    z.object({
      _id: z.string(),
      name: z.string().optional(),
      email: z.string(),
      roles: z.array(z.string()).optional(),
    })
  ),
});
export type ActiveUsersResponse = z.infer<typeof activeUsersResponseSchema>;

export const facilityUsersParamsSchema = z.object({
  isArchived: z.boolean(),
  facilityId: z.string(),
});
export type FacilityUsersParams = z.infer<typeof facilityUsersParamsSchema>;

export const workerStatusSchema = z.object({
  type: z.literal("worker"),
  attributes: z.object({
    id: z.string(),
    homeHealthEnabled: z.boolean(),
  }),
});
export type WorkerStatus = z.infer<typeof workerStatusSchema>;

export const workerStatusRequestSchema = z.object({
  data: z.object({
    type: workerStatusSchema.shape.type,
    attributes: workerStatusSchema.shape.attributes.omit({ id: true }),
  }),
  errors: z.array(responseErrorSchema).optional(),
});
export type WorkerStatusRequest = z.infer<typeof workerStatusRequestSchema>;

export const workerStatusResponseSchema = z.object({
  data: workerStatusSchema,
  errors: z.array(responseErrorSchema).optional(),
});
export type WorkerStatusResponse = z.infer<typeof workerStatusResponseSchema>;
